// Short, low descending tone for incorrect / skipped input (sprint, etc.).

let sharedCtx: AudioContext | null = null;

function getContext(): AudioContext | null {
  if (sharedCtx) return sharedCtx;
  if (typeof window === 'undefined') return null;
  try {
    const Ctx =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!Ctx) return null;
    sharedCtx = new Ctx();
  } catch {
    sharedCtx = null;
  }
  return sharedCtx;
}

function playTone(
  ctx: AudioContext,
  frequency: number,
  startAt: number,
  peakGain: number,
  durationSec: number,
): void {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = frequency;
  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(peakGain, startAt + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + durationSec);
  osc.connect(gain).connect(ctx.destination);
  osc.start(startAt);
  osc.stop(startAt + durationSec + 0.02);
}

/** Soft downward “miss” — ~200 ms. */
export function playMissChime(): void {
  const ctx = getContext();
  if (!ctx) return;
  void ctx.resume().catch(() => {});
  const t0 = ctx.currentTime;
  playTone(ctx, 330, t0, 0.09, 0.12);
  playTone(ctx, 220, t0 + 0.1, 0.08, 0.14);
}
